import { NativeDateAdapter } from '@angular/material';

export class HCIDateAdapter extends NativeDateAdapter {

    parse(value: any): Date | undefined {
        if ((typeof value === 'string') && (value.indexOf('/') > -1)) {
            const str: string[] = value.split('/');
            const year: number = Number(str[2]);
            const month: number = Number(str[1]) - 1;
            const date: number = Number(str[0]);
            let tmzo: number = new Date(year, month, date).getTimezoneOffset();
            tmzo = tmzo <= 0 ? 0 : 1;

            return new Date(Date.UTC(year, month, date + tmzo));
        }
        const timestamp: number = typeof value === 'number' ? value : Date.parse(value);
        return isNaN(timestamp) ? undefined : new Date(timestamp);
    }

    createDate(year: number, month: number, date: number): Date {
        if (month < 0 || month > 11 || date < 1) {
            return undefined;
        }

        const result: Date = this._customCreateDateWithOverflow(year, month, date);

        return result;
    }

    private _customCreateDateWithOverflow(year: number, month: number, date: number): Date {
        // doing this you avoid trouble with Daylight Saving Time
        let tmzo: number = new Date(year, month, date).getTimezoneOffset();
        tmzo = tmzo <= 0 ? 0 : 1;
        const result: Date = new Date(Date.UTC(year, month, date + tmzo));

        // We need to correct for the fact that JS native Date treats years
        // in range [0, 99] as abbreviations for 19xx.
        if (year >= 0 && year < 100) {
            result.setFullYear(this.getYear(result) - 1900);
        }

        return result;
    }

    private _to2digit(n: number): string {
        return ('00' + n).slice(-2);
    }
}



// WEBPACK FOOTER //
// ./src/app/dateFormat/hcidateadapter.ts